import React from 'react';
import PropTypes from 'prop-types';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import lineIcon from './line.svg';

const BitLineComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.line}
    imgSrc={lineIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="L"
  />
);

BitLineComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitLineComponent;
